// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-header[data-v-882f9ac2],[data-v-882f9ac2] {font-size:20px;font-weight:700;margin-bottom:15px;padding:0}@media(max-width:991.98px){.section-header[data-v-882f9ac2],[data-v-882f9ac2] {font-size:16px;font-weight:700!important;text-transform:uppercase}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
